import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Lock, User, Eye, EyeOff } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../services/api';
import { getApiConnectionErrorMessage } from '../utils/apiErrorHints';
import { useAuth } from '../context/AuthContext';
import './AuthPages.css';

export default function RegisterPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) return toast.error('Password must be at least 6 characters');
    setLoading(true);
    try {
      const res = await api.post('/auth/register', form);
      login(res.data.token, res.data.user);
      toast.success('Account created! Welcome aboard!');
      navigate('/dashboard');
    } catch (err) {
      const net =
        err.code === 'ERR_NETWORK' ||
        err.message === 'Network Error' ||
        !err.response;
      toast.error(
        err.response?.data?.message ||
          (net ? getApiConnectionErrorMessage() : 'Registration failed')
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg-glow" />
      <div className="auth-card">
        <Link to="/" className="auth-brand">⚡ Zip2Extract <span>AI</span></Link>
        <h2>Create account</h2>
        <p className="auth-sub">Start exploring code for free</p>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="input-group">
            <User size={16} className="input-icon" />
            <input className="input" type="text" placeholder="Your name"
              value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          </div>
          <div className="input-group">
            <Mail size={16} className="input-icon" />
            <input className="input" type="email" placeholder="Email address"
              value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
          </div>
          <div className="input-group">
            <Lock size={16} className="input-icon" />
            <input className="input" type={showPass ? 'text' : 'password'} placeholder="Password (min 6 chars)"
              value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
            <button type="button" className="input-toggle" onClick={() => setShowPass(!showPass)}>
              {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
          <button type="submit" className="btn btn-primary w-full" disabled={loading}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>
        <p className="auth-footer">Already have an account? <Link to="/login">Sign in</Link></p>
      </div>
    </div>
  );
}
